import { render } from "./AudioPlayer.vue?vue&type=template&id=85a47e24&scoped=true&bindings={\"audioSrc\":\"props\",\"handlePlay\":\"setup\",\"handlePause\":\"setup\",\"hanle_slider_change\":\"setup\",\"dragStart\":\"setup\"}"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=85a47e24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-85a47e24"

export default script